<template>
	<!-- 修改密码 -->
	<el-dialog title="修改密码" :visible.sync="passModel" top="5vh" @close="hide">
		<!-- 表单内容 -->
		<el-form :rules="pass_rules" ref="pass_form" :model="pass_arr" label-width="100px">
			<el-form-item label="当前密码" prop="old_pass">
				<el-input v-model="pass_arr.old_pass" :maxlength="16" :minlength="6" show-password placeholder="登录密码" size="small"
				 style="width: 34%;"></el-input>
			</el-form-item>

			<el-form-item label="新密码" prop="pass1">
				<el-input v-model="pass_arr.pass1" :maxlength="16" :minlength="6" show-password placeholder="新密码" size="small"
				 style="width: 34%;"></el-input>
			</el-form-item>
			<el-form-item label="确认密码" prop="pass2">
				<el-input v-model="pass_arr.pass2" :maxlength="16" :minlength="6" show-password placeholder="确认密码" size="small"
				 style="width: 34%;"></el-input>
			</el-form-item>
		</el-form>


		<div slot="footer" class="dialog-footer">
			<el-button @click="hide">取 消</el-button>
			<el-button type="primary" @click="submitpass">确 定</el-button>
		</div>
	</el-dialog>
</template>

<script>
	export default {
		props: {
			passModel: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				pass_arr: {
					old_pass: '',
					pass1: '',
					pass2: '',
				},
				pass_rules: {
					old_pass: [{
						required: true,
						message: "请输入当前密码",
						trigger: 'blur',
					}, ],

					pass1: [{
							min: 6,
							max: 16,
							message: '密码长度在 6 到 16 个字符',
							trigger: 'blur'
						},
						{
							required: true,
							message: "请输入新密码",
							trigger: 'blur',
						}
					],
					pass2: [{
							min: 6,
							max: 16,
							message: '密码长度在 6 到 16 个字符',
							trigger: 'blur'
						},
						{
							required: true,
							message: "请输入确认密码",
							trigger: 'blur',
						}
					],

				},
			}
		},
		methods: {
			hide(){
				this.$emit('hide')
			},
			//提交
			submitpass() {
				if (this.pass_arr.pass1 != this.pass_arr.pass2) {
					this.$message({
						message: '两次密码输入不一致',
						type: 'error'
					});
					return
				}
				this.$refs.pass_form.validate(res => {
					if (res) {
						
						this.submitApi()
					}
				})
				
			},
			submitApi(){
				this.api.post('/user/editPass', this.pass_arr).then(res => {
					let all = res.data
					if (all.code == 1) {
						this.$message({
							message:   '修改成功',
							type: 'success'
						});
						this.hide()
					}
					
				}).catch(err => {
					
				})
			}
		}
	}
</script>

<style>
</style>
